import { createAction, handleActions } from 'redux-actions';
import { PpasModule } from './details';

export interface OrganizationConfigResponse {
  data: {
    id: string
    type: string
    attributes: {
      apps: PpasModule[]
      common: PpasModule[]
    }
  }
}

export const fetchOrganizationConfigSucceeded = createAction<OrganizationConfigResponse, OrganizationConfigResponse>(
  '@platform/query/organization/getConfig/success',
  (payload: OrganizationConfigResponse) => payload,
);
export const fetchOrganizationConfigFailed = createAction(
  '@platform/query/organization/getConfig/failed',
);

export type ConfigState = {
  isLoading: true
  failed: false
  availableProducts: []
  domain: string
} | {
  isLoading: false
  failed: false
  availableProducts: PpasModule[]
  domain: string
} | {
  isLoading: false
  failed: true
  availableProducts: []
  domain: string
};

const initialState: ConfigState = {
  isLoading: true,
  failed: false,
  availableProducts: [],
  domain: document.location.hostname,
};

export default handleActions<ConfigState, OrganizationConfigResponse>({
  [fetchOrganizationConfigSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    failed: false,
    availableProducts: payload.data.attributes.apps,
  }),
  [fetchOrganizationConfigFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
    availableProducts: [],
  }),
}, initialState);
